<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/account")
          i.fa.fa-users
          span.ml-1 {{ $t("ui.account") }}
      b-breadcrumb-item
        router-link(to="/account/ibank_list")
          i.fa.fa-university
          span.ml-1 {{ $t("ui.ibank_list") }}
  div.row
    div.col-md-6
      div.card
        div.card-body
          b-row
            .col-sm-12.col-md-12.col-lg-12.col-xl-12
              b-table#tblList.table-sm.table-hover(show-empty :empty-text="$t('message.no_records')" :no-local-sorting="true" responsive :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :items="list" :fields="fields" :per-page="perPage" :filter="filter" @sort-changed="sortingChanged" :tbody-tr-class="rowClass")
                template(v-slot:cell(index)="row")
                  span {{ row.index + 1 }}
                template(v-slot:cell(status)="row")
                  select(v-model="row.item.status" @change="updateStatus(row.item, $event)")
                    option(value="true") {{ $t("ui.active") }}
                    option(value="false") {{ $t("ui.closed") }}
</template>

<script>
import config from "@/config"
import errorTags from "@/errorTags"
import SubmitButton from "@/library/SubmitButton.vue"

export default {
  components: {
    SubmitButton
  },
  data() {
    return {
      loading: false,
      filter: null,
      sortBy: "bank_id",
      sortDesc: false,
      list: [],
      submission: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  validations: {},
  computed: {
    fields() {
      return [
        {
          key: "index",
          label: "#",
          class: "text-center align-middle",
          thStyle: {
            width: "5% !important"
          }
        },
        {
          key: "bank_id",
          label: this.$t("ui.bank_id"),
          class: "text-left align-middle",
          thStyle: {
            width: "20%"
          }
        },
        {
          key: "bank_name",
          label: this.$t("ui.bank_name"),
          class: "text-left align-middle",
          thStyle: {
            width: "50%"
          }
        },
        {
          key: "status",
          label: this.$t("ui.status"),
          class: "text-left align-middle",
          thStyle: {
            width: "20%"
          }
        },
      ]
    },
    perPage() {
      return this.$store.getters.pageSize
    },
    direction() {
      return this.sortDesc ? "DESC" : "ASC"
    }
  },
  mounted: function() {
    this.submit()
  },
  methods: {
    rowClass: function(item, type) {
      if (!item) return
      if (item.status === false)  return 'table-danger'
    },
    sortingChanged: function(ctx) {
      if (ctx.sortBy !== this.sortBy) {
        this.sortDesc = false
      } else {
        this.sortDesc = this.direction === "ASC"
      }

      this.sortBy = ctx.sortBy
      this.submit()
      this.refreshTable()
    },
    refreshTable: function() {
      this.$root.$emit("bv::table::refresh", "tblList")
    },
    updateStatus: function(account, eventStatus) {
      this.$swal({
        title: this.$t("ui.status"),
        text: this.$t("message.update_ibank_status_confirm"),
        type: "warning",
        showCancelButton: true,
        allowOutsideClick: false
      }).then(result => {
        if (result.value) {
          let bank_id = account.bank_id
          let new_status = eventStatus.srcElement.value
          this.loading = true
          this.$store
            .dispatch("account/updateIBankStatus", { bank_id, new_status })
            .then(response => {
              this.loading = false
              this.submission.success = response.success
              if (this.submission.success == true) {
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.update_ibank_status_success"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    this.submit();
                  }
                });
              }
            })
            .catch(response => {
              this.loading = false
              this.$swal({
                title: this.$t("ui.failed"),
                text: this.$t("message.update_ibank_status_cancel"),
                type: "success",
                allowOutsideClick: false
              }).then(isConfirm => {
                if (isConfirm) {
                  this.submit()
                  eventStatus.srcElement.value = account.status
                }
              });
            });
        } else if (
          // Read more about handling dismissals
          result.dismiss === this.$swal.DismissReason.cancel
        ) {
          this.loading = false
          this.$swal({
            title: this.$t("ui.cancel"),
            text: this.$t("message.update_account_status_cancel"),
            type: "error",
            allowOutsideClick: false
          }).then(isConfirm => {
            if (isConfirm) {
              this.submit()
              eventStatus.srcElement.value = account.status
            }
          });
        }
      });
    },
    submit: function() {
      if (!this.$v.$invalid) {
        this.loading = true
        this.$store
          .dispatch("account/getIBankList")
          .then(response => {
            this.loading = false
            this.submission.success = response.success
            if (this.submission.success == true) {
              this.list = response.data
            }
          })
          .catch(response => {
            this.loading = false
            this.submission.success = response.success
            this.submission.status = this.$t("message." + response.errorTag);
          });
      }
    }
  }
};
</script>